import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const VettedIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M10.647 1.536 9.374.493a2.16 2.16 0 0 0-2.748 0L5.353 1.536a2.2 2.2 0 0 1-.895.439l-1.594.363a2.225 2.225 0 0 0-1.714 2.19l.007 1.662c.002.342-.074.68-.22.987L.22 8.673a2.26 2.26 0 0 0 .612 2.73l1.281 1.03c.263.213.475.484.62.792l.702 1.502a2.18 2.18 0 0 0 2.477 1.215l1.59-.377c.327-.078.667-.078.994 0l1.59.377a2.18 2.18 0 0 0 2.477-1.215l.702-1.502c.145-.308.357-.58.62-.791l1.281-1.032a2.26 2.26 0 0 0 .612-2.73l-.715-1.495a2.3 2.3 0 0 1-.221-.987l.007-1.663a2.225 2.225 0 0 0-1.714-2.189l-1.594-.363a2.2 2.2 0 0 1-.895-.44m-8.873 8.698a.76.76 0 0 1-.2-.914l.715-1.496c.245-.512.37-1.073.368-1.64L2.65 4.521a.725.725 0 0 1 .547-.72l1.594-.364a3.7 3.7 0 0 0 1.513-.741l1.272-1.043a.66.66 0 0 1 .848 0l1.272 1.043c.44.36.957.615 1.513.741l1.594.364a.725.725 0 0 1 .547.72l-.007 1.663a3.8 3.8 0 0 0 .367 1.64l.715 1.496a.76.76 0 0 1-.199.914l-1.28 1.031c-.444.357-.798.81-1.038 1.325l-.703 1.502a.68.68 0 0 1-.772.39l-1.59-.377a3.65 3.65 0 0 0-1.686 0l-1.59.377a.68.68 0 0 1-.772-.39l-.703-1.502a3.7 3.7 0 0 0-1.037-1.325z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M11.195 6.134a.75.75 0 0 1 .005 1.06l-3.835 3.872L4.8 8.476a.75.75 0 0 1 1.066-1.055l1.5 1.513 2.768-2.795a.75.75 0 0 1 1.06-.005"
      clipRule="evenodd"
    />
  </svg>
);
VettedIcon.id = 'VettedIcon';
VettedIcon.displayName = 'VettedIcon';
export default VettedIcon;
